<template>
    <div class="footer fixed bottom-0 left-0 w-full" :class="{ 'has-power-by': hasPoweredBy }">
        <template v-if="hasPoweredBy">
            <div class="text-center mx-auto my-6 w-full">
                <img src="@/assets/img/logo/buzzebees-logo-dark.svg" class="mx-auto" alt />
            </div>
        </template>
        <!-- <img class="border-panel" src="@/assets/img/power-by.svg" alt /> -->
        <div class="flex hight-max">
            <div class="flex-1 color-1"></div>
            <div class="flex-1 color-2"></div>
            <div class="flex-1 color-3"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
    props: {
        hasPoweredBy: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="scss" scoped>
.hight-max {
    height: 5px;
    max-height: 5px;
}
.color-1 {
    height: 5px;
    background-image: linear-gradient(to right, #1c2c73 0%, #016cb8 100%);
}
.color-2 {
    height: 5px;
    background-image: linear-gradient(to right, #72292f 0%, #e00238 100%);
}
.color-3 {
    height: 5px;
    background-image: linear-gradient(to right, #027c40 0%, #53b230 100%);
}
</style>
